import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Card, Input } from "@/components/erp/ui";
import { Trophy } from "lucide-react";

const MEDAL = ["bg-amber-400 text-white", "bg-slate-300 text-slate-800", "bg-orange-300 text-white"];

export const BonusLeaderboard = () => {
  const [month, setMonth] = useState(new Date(Date.now() + 7 * 3600e3).toISOString().slice(0, 7)); const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/role-bonus/leaderboard", { params: { month } }).then(({ data }) => setD(data)).catch(() => setD({ rows: [] })); }, [month]);
  return (
    <Card className="p-5" data-testid="bonus-leaderboard">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        <Trophy className="w-4 h-4 text-amber-500" /><b className="text-sm">Leaderboard Bonus Tim</b>
        <Input type="month" data-testid="lb-month" value={month} onChange={(e) => setMonth(e.target.value)} className="ml-auto border border-slate-300 rounded-lg px-2 py-1 text-xs" />
      </div>
      <p className="text-xs text-slate-500 mb-3">Peringkat dari poin penambahan nilai & bonus per aturan (KPI per Rule) bulan ini. Nominal Rupiah hanya terlihat oleh admin utama dan pemiliknya.</p>
      {!d && <p className="text-xs text-slate-400">Menghitung…</p>}
      <div className="space-y-2">{(d?.rows || []).map((x) => (
        <div key={x.employee_id} className={`rounded-xl border p-3 ${x.me ? "border-sky-300 bg-sky-50" : "border-slate-200"}`} data-testid={`lb-row-${x.rank}`}>
          <div className="flex flex-wrap items-center gap-3">
            <span className={`inline-flex w-7 h-7 rounded-full items-center justify-center text-xs font-bold ${MEDAL[x.rank - 1] || "bg-slate-100"}`}>{x.rank}</span>
            <b className="text-sm">{x.name}{x.me ? " (saya)" : ""}</b>
            <span className="ml-auto text-sm font-semibold text-sky-700" data-testid={`lb-points-${x.rank}`}>+{x.points} poin</span>
            {x.rp != null && <span className="text-sm font-semibold text-emerald-700" data-testid={`lb-rp-${x.rank}`}>{formatIDR(x.rp)}</span>}
          </div>
          <div className="flex flex-wrap gap-1.5 mt-2">{x.rules.map((r) => <span key={r.rule} className="text-[11px] px-2 py-0.5 rounded-full bg-white border border-slate-200">{r.label} ×{r.count}{r.points ? ` · +${r.points}` : ""}{r.rp ? ` · ${formatIDR(r.rp)}` : ""}</span>)}</div>
        </div>))}</div>
      {d && !d.rows.length && <p className="text-xs text-slate-400" data-testid="lb-empty">Belum ada yang memenuhi syarat bonus per aturan bulan ini.</p>}
    </Card>
  );
};
